module.exports = __webpack_public_path__ + "static/img/270_TO8_2374_og.18317df.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/270_TO8_2374_og.jpg
// module id = b5FY
// module chunks = 0